import { AngleLeft } from "flowbite-react-icons/outline";
import PropTypes from "prop-types";
import { NavLink } from "react-router";

ArrowLeftButton.propTypes = {
  link: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.oneOf(["round", "regular"]),
  children: PropTypes.node,
  hover: PropTypes.bool,
};

export default function ArrowLeftButton({ link, style = "round", children, hover, onClick }) {
  const handleOnClick = (e) => {
    e.preventDefault();
    onClick(e);
  };

  if (link) {
    if (style === "round") {
      return (
        <NavLink
          unstable_viewTransition
          to={link}
          className={`btn bg-base-200 border border-neutral-200 btn-circle btn-ghost hover:shadow-md hover:bg-secondary hover:text-white ${hover && "sj-light-blue text-white shadow-md"}`}

          // className="btn bg-base-200 border border-neutral-200 btn-circle hover:shadow-md hover:bg-blue-500 hover:text-white"
        >
          <AngleLeft />
        </NavLink>
      );
    }

    return (
      <NavLink
        unstable_viewTransition
        to={link}
        className="btn bg-base-200 border border-neutral-200 btn-circle btn-ghost hover:shadow-md hover:primary hover:text-white"
      >
        {children}
        <AngleLeft />
      </NavLink>
    );
  }

  return (
    <button
      type="button"
      className={`btn bg-base-200 border border-neutral-200 btn-circle btn-ghost hover:shadow-md hover:bg-secondary hover:text-white ${hover && "sj-light-blue text-white shadow-md"}`}
      onClick={handleOnClick}
    >
      <AngleLeft />
    </button>
  );
}
